module.exports = __webpack_public_path__ + "static/media/AlertTriangle.fda78342.svg";